module.exports = {
	"articleTitle1": "Wake up and smell the testosterone",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Fletcher Hall",
	"articleLink1": "https://www.michigandaily.com/content/wake-and-smell-testosterone",
	"articleLink2": "https://www.michigandaily.com/content/most-expensive-campus-housing-living-lap-luxury",
	"articleSnippet1": "Apr 8, 2008 ... Many people already have a hard time getting dates, but the men who live in \nBaits Houses and Fletcher Hall have it even harder. Those dorms ...",
	"articleSnippet2": "Mar 18, 2007 ... The hall's 110 students enjoy private bathrooms and carpeting. That's why ... The \ncheapest residence hall is Fletcher Hall. Room and board at ...",
	"totalMisc": 0,
	"articleTitle2": "The most expensive on-campus housing",
	"address": "915 Sybil St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.270195,
		"lng": -83.742717
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/fletcherhall.json
// module id = 879
// module chunks = 0